import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Pagination from "../components/Pagination";

function HistorialLlamadas() {
  const [llamadas, setLlamadas] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [pageSize, setPageSize] = useState(25);  // 👈 Valor por defecto: 25
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  
  // ✅ Usa useCallback para evitar re-renderizados innecesarios
  const fetchLlamadas = useCallback((url) => {
    // Si no se pasa una URL, construye una con el page_size actual
    if (!url) {
      url = `${API_URL}/api/registro-llamadas/`;
    }
  
    // 🔁 Usamos URL API-safe para asegurar que page_size se actualiza correctamente
    const parsedUrl = new URL(url, window.location.origin);
    parsedUrl.searchParams.set("page_size", pageSize); // 🧠 Forzar page_size actual
  
    axios.get(parsedUrl.toString())
      .then(response => {
        setLlamadas(response.data.results);
        setNextPage(response.data.next);
        setPrevPage(response.data.previous);
      })
      .catch(error => console.error("Error al obtener el historial de llamadas:", error));
  }, [API_URL, pageSize]);
  
  

  useEffect(() => {
    fetchLlamadas();
  }, [pageSize,fetchLlamadas]);  // ✅ Ahora React no mostrará advertencias

  return (
    <div>
      <h2>📞 Historial de Llamadas</h2>
      <div className="contenedor">
      
        {/* 🔽 Selector de número de registros */}
        <div className="d-flex align-items-center mb-3">
          <label htmlFor="pageSizeSelect" className="form-label me-2">Registros:</label>
          <select
            id="pageSizeSelect"
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
            className="form-select"
            style={{ width: "100px" }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
        </div>
        <table className="table table-striped table-hover">
          <thead className="table-dark">
            <tr>
              <th>Alarma</th>
              <th>Teléfono</th>
              <th>Fecha</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            {llamadas.map(llamada => (
              <tr key={llamada.id}>
                <td>{llamada.alarma_nombre}</td>
                <td>{llamada.telefono}</td>
                <td>{new Date(llamada.fecha_hora).toLocaleString()}</td>
                <td>{llamada.estado}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* 🔵 Paginación Reutilizable */}
        <Pagination 
          prevPage={prevPage} 
          nextPage={nextPage} 
          fetchPage={fetchLlamadas} 
        />
      </div>
    </div>
  );
}

export default HistorialLlamadas;
